import React from "react";

import "./networkSection.css";

import networkBanner from "../../../assets/networkBanner.png";

const NetworkSection = () => {
  return (
    <div className="networkSection">
      <div className="networkLeft">
        <img src={networkBanner} className="networkBanner" />
      </div>

      <div className="networkRight">
        <div className="networkHeading">Learn, Network, Empower & Grow</div>
        <div className="networkContent">
          Classplus in association with Anant Laddha (Founder, Invest Aaj For
          Kal) invites you to FinClave 2022, a meet-n-greet exclusively for the
          finance content creators of India. <br />
          <br />
          True heroes don't wear capes, they educate and empower the masses
          about financial freedom!
          <br />
          <br />
          That’s why! We are keen on CELEBRATING our very own Finfluencers!
          <br />
          <br />
          Build deeper relationships, collaborate, inspire, and get inspired!{" "}
          <br />
          <br />
          COUNT ME IN!
        </div>
      </div>
    </div>
  );
};

export default NetworkSection;
